export const SET_GENERAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.general.data = {
      ...state.general.data,
      ...payload,
    }
    state.general.lastUpdate = new Date()
  }
}

export const SET_GENERAL_LOADING = (state, payload) => {
  state.general.loading = payload
}
